'use client';

import { useTranslations } from 'next-intl';
import DocumentPageShell from '@/components/sections/shared/DocumentPageShell';
import PolicyPageContent from '@/components/sections/shared/PolicyPageContent';
import type { TermsAndConditionsData } from '@/types/terms-and-conditions';

interface TermsAndConditionsProps {
  locale: string;
  data: TermsAndConditionsData | null;
}

export default function TermsAndConditions({ locale, data }: TermsAndConditionsProps) {
  const t = useTranslations('termsAndConditions');

  if (!data) {
    return (
      <DocumentPageShell title={t('error.title')}>
        <div className="rounded-2xl border border-[#e4e4e4] bg-white p-8 text-center shadow-sm">
          <p className="text-base text-[#737373]">{t('error.message')}</p>
        </div>
      </DocumentPageShell>
    );
  }

  return (
    <PolicyPageContent locale={locale} data={data} effectiveDateLabel={t('effectiveDateLabel')} />
  );
}
